// DatepickerFilter.js

import { defineComponent, ref, watch } from "/Scripts/vue.esm-browser.js";
const html = String.raw;

export default defineComponent({
    name: "DatepickerFilter",

    props: {
        dateRangeStart: {
            type: String,
            default: "",
        },
        dateRangeEnd: {
            type: String,
            default: "",
        },
        dateRange: {
            type: Array,
            default: [],
        },
    },

    emits: ["update:updateDateRange"],

    setup(props, { emit }) {
        const rootEl = ref(null);
        const instanceUid = `dp_${Math.random().toString(36).slice(2, 9)}`;

        // Handle quick date range selection
        const dateStart = ref(props.dateRangeStart);
        const dateEnd = ref(props.dateRangeEnd);

        // const setQuickDateRange = (days) => {
        //     const today = new Date();
        //     const endDate = new Date(today);
        //     endDate.setDate(today.getDate() + days);

        //     dateStart.value = today.toISOString().split("T")[0];
        //     dateEnd.value = endDate.toISOString().split("T")[0];
        //     emit("update:updateDateRange", dateStart.value, dateEnd.value);
        // };
        const formatDate = (date) => {
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const dd = String(date.getDate()).padStart(2, "0");
            return `${yyyy}/${mm}/${dd}`;
        };

        const setDateRange = (dateRange) => {
            dateStart.value = formatDate(dateRange[0]);
            dateEnd.value = formatDate(dateRange[1]);
            emit("update:updateDateRange", dateStart.value, dateEnd.value);
        };
        watch(
            () => props.dateRangeStart,
            (newVal) => {
                dateStart.value = newVal;
            },
        );
        watch(
            () => props.dateRangeEnd,
            (newVal) => {
                dateEnd.value = newVal;
            },
        );
        // Price range state
        return {
            instanceUid,
            setDateRange,
            dateStart,
            dateEnd,
            rootEl,
        };
    },
    mounted() {
        this.$nextTick(() => {
            flatpickrService.init(this.instanceUid, this.setDateRange, this.rootEl);
        });
    },

    template: html`
        <div class="datePicker_popup" ref="rootEl">
            <div class="top">
                <div class="left_wrap">
                    <div class="radio" data-range-days="14">
                        <input
                            class="radio_input"
                            type="radio"
                            :id="instanceUid + '-fw-0'"
                            :name="instanceUid + '-drone'"
                        />
                        <label class="radio_label" :for="instanceUid + '-fw-0'">
                            <div class="radio_textBox"><span>14天內</span></div>
                        </label>
                    </div>

                    <div class="radio" data-range-days="30">
                        <input
                            class="radio_input"
                            type="radio"
                            :id="instanceUid + '-fw-1'"
                            :name="instanceUid + '-drone'"
                        />
                        <label class="radio_label" :for="instanceUid + '-fw-1'">
                            <div class="radio_textBox"><span>30天內</span></div>
                        </label>
                    </div>

                    <div class="radio" data-range-months="2">
                        <input
                            class="radio_input"
                            type="radio"
                            :id="instanceUid + '-fw-2'"
                            :name="instanceUid + '-drone'"
                        />
                        <label class="radio_label" :for="instanceUid + '-fw-2'">
                            <div class="radio_textBox">
                                <span>兩個月內</span>
                            </div>
                        </label>
                    </div>

                    <div class="radio" data-range-months="3">
                        <input
                            class="radio_input"
                            type="radio"
                            :id="instanceUid + '-fw-3'"
                            :name="instanceUid + '-drone'"
                        />
                        <label class="radio_label" :for="instanceUid + '-fw-3'">
                            <div class="radio_textBox">
                                <span>三個月內</span>
                            </div>
                        </label>
                    </div>

                    <div class="radio" data-range-months="4">
                        <input
                            class="radio_input"
                            type="radio"
                            :id="instanceUid + '-fw-4'"
                            :name="instanceUid + '-drone'"
                        />
                        <label class="radio_label" :for="instanceUid + '-fw-4'">
                            <div class="radio_textBox">
                                <span>四個月內</span>
                            </div>
                        </label>
                    </div>

                    <div class="radio" data-range-months="6">
                        <input
                            class="radio_input"
                            type="radio"
                            :id="instanceUid + '-fw-5'"
                            :name="instanceUid + '-drone'"
                        />
                        <label class="radio_label" :for="instanceUid + '-fw-5'">
                            <div class="radio_textBox"><span>半年內</span></div>
                        </label>
                    </div>
                </div>
                <input
                    type="text"
                    id="datepicker"
                    class="costom_datepicker"
                    placeholder="選擇日期"
                />
            </div>
            <div class="btn_group">
                <button class="reset">取消</button>
                <button class="enter">確認</button>
            </div>
        </div>
        <!--<div class="filterbox filterbox-date">
            <div class="filter_title">出發日期</div>
            <div class="filterSpace_input">
                <div class="input_bar">
                    <button class="input_bar_date-start">
                        {{ dateRange[0] }}
                    </button>
                    <span>~</span>
                    <button class="input_bar_date-end">
                        {{ dateRange[1] }}
                    </button>
                </div>
            </div>
        </div>-->
    `,
});
